// src/components/ResultsScreen.jsx
import React from "react";

export function ResultsScreen({
  username,
  quizName,
  score,
  questions,
  answers,
  onRetake,
  onBack,
}) {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-md space-y-6">
      <h2 className="text-xl font-bold text-gray-800">Quiz Finished!</h2>

      <div className="space-y-1">
        <p className="text-gray-700">
          <span className="font-semibold">User:</span> {username}
        </p>
        <p className="text-gray-700">
          <span className="font-semibold">Quiz:</span> {quizName}
        </p>
        <p className="text-gray-700">
          <span className="font-semibold">Score:</span> {score} / {questions.length} (
          {((score / questions.length) * 100).toFixed(1)}%)
        </p>
      </div>

      {/* Detailed Answers Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm">
          <thead className="bg-gray-200 text-left">
            <tr>
              <th className="border px-4 py-2">Question</th>
              <th className="border px-4 py-2">Your Answer</th>
              <th className="border px-4 py-2">Correct</th>
              <th className="border px-4 py-2">Result</th>
            </tr>
          </thead>
          <tbody className="bg-white even:bg-gray-50">
            {answers.map((a, i) => (
              <tr key={i}>
                <td className="border px-4 py-2">{a.question}</td>
                <td className="border px-4 py-2">
                  {a.selected.length > 0
                    ? a.selected.map((idx) => String.fromCharCode(65 + idx)).join(", ")
                    : "No Answer"}
                </td>
                <td className="border px-4 py-2">
                  {a.correct.map((idx) => String.fromCharCode(65 + idx)).join(", ")}
                </td>
                <td className="border px-4 py-2 text-center">
                  {JSON.stringify(a.selected.sort()) ===
                  JSON.stringify(a.correct.sort())
                    ? "✅"
                    : "❌"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-4">
        <button
          onClick={onRetake}
          className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 transition"
        >
          Retake Quiz
        </button>
        <button
          onClick={onBack}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
